import * as React from "react";

export const COOKIEYES_SETTINGS = {
  scriptId: "cookieyes",
  scriptSrc:
    "https://cdn-cookieyes.com/client_data/2eccd27ca726d42b8150fb419c47e072/script.js",
};

export const COOKIEYES_CATEGORIES = {
  analytics: "analytics",
  advertisement: "advertisement",
  functional: "functional",
};

export const GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-DL4PP0M2HB";

export const ConsentManagedScript = ({
  id,
  src,
  category,
  children,
}) => {
  if (children) {
    return (
      <script
        id={id}
        type="text/plain"
        data-cookieyes={`cookieyes-${category}`}
        dangerouslySetInnerHTML={{ __html: children }}
      />
    );
  }

  return (
    <script
      id={id}
      type="text/plain"
      data-cookieyes={`cookieyes-${category}`}
      src={src}
    />
  );
};

const CookieConsent = () => (
  <script
    id={COOKIEYES_SETTINGS.scriptId}
    type="text/javascript"
    src={COOKIEYES_SETTINGS.scriptSrc}
  />
);

export default CookieConsent;
